function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
var SearchField = /*#__PURE__*/function (_React$Component) {
  function SearchField(props) {
    _classCallCheck(this, SearchField);
    return _callSuper(this, SearchField, [props]);
  }
  _inherits(SearchField, _React$Component);
  return _createClass(SearchField, [{
    key: "onInputChange",
    value: function onInputChange(e) {
      var searchQuery = e.target.value;
      this.props.updateSearchQuery(searchQuery);
      if (searchQuery === "") {
        this.props.onClearAll();
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(e) {
      e.preventDefault();
      this.props.handleSearch(this.props.searchQuery, false, "search_field");
    }
  }, {
    key: "handleSearchOnEnterKeyDown",
    value: function handleSearchOnEnterKeyDown(e) {
      if (e.keyCode === 13) {
        // Prevent page form submitting
        var form = document.querySelector("form");
        form.submit = null;
        form.onsubmit = null;
        this.handleSearch(e);
      }
    }
  }, {
    key: "onClearSearch",
    value: function onClearSearch(e) {
      e.preventDefault();
      this.props.searchInputRef.current.focus();
      this.props.updateSearchQuery("");
      this.props.onClearAll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        searchQuery = _this$props.searchQuery,
        searchInputRef = _this$props.searchInputRef;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
        ref: searchInputRef,
        type: "text",
        placeholder: placeholder,
        onChange: function onChange(e) {
          return _this.onInputChange(e);
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleSearchOnEnterKeyDown(e);
        },
        value: searchQuery
      }), searchQuery.length > 0 && /*#__PURE__*/React.createElement("button", {
        className: "resource-center__search__field__clear-button",
        onClick: function onClick(e) {
          return _this.onClearSearch(e);
        },
        title: "Clear search"
      }), /*#__PURE__*/React.createElement("button", {
        className: "resource-center__search__field__search-button",
        onClick: function onClick(e) {
          return _this.handleSearch(e);
        },
        title: "Search"
      }));
    }
  }]);
}(React.Component);
export default SearchField;